module.exports = __webpack_public_path__ + "img/flank2.cc3cc336.png";